<template>
  <div class="stone" :id="identifier" lang="en" :class="{ mobile : isMobile }">
    <div id="windowcontent">
      <img v-if="!links && !credits" class="bgimage" src="../assets/about-01.png"/>
      <img v-if="credits" class="bgimage" src="../assets/about-03.png"/>
      <img v-if="links" src="../assets/about-02.png">
      <div id="textcontainer">
      <vue-markdown v-if="!links" lang="en">{{ textcontent }}</vue-markdown>
      <a class="links" :href="bc" target="_blank" v-if="links"><img :src="'https://traumgarten.dev0ted.tech/' + bc_image.url"/></a>
      <a class="links" :href="sc" target="_blank" v-if="links"><img :src="'https://traumgarten.dev0ted.tech/' + sc_image.url"/></a>
      <a class="links" :href="ig" target="_blank" v-if="links"><img :src="'https://traumgarten.dev0ted.tech/' + ig_image.url"/></a>
      <a :href="'mailto:'+ mail" target="_blank" v-if="links">Contact</a>
    </div>
    </div>
    </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import interact from "interactjs";

export default {
  name: "AboutStone",
  components: { VueMarkdown },
  props: [ 'textcontent', 'identifier', 'isMobile', 'links', 'bc', 'sc', 'bc_image', 'sc_image', 'mail', 'ig', 'ig_image', 'credits'],
  data() {
    return {
      x: null,
      y: null
    }
  },
    mounted() {
    let VueThis = this;
    VueThis.enableDragDrop("#"+this.$props.identifier, "#windowcontent", VueThis.x, VueThis.y);
  },
  methods: {
    enableDragDrop(container, handleElement, GlobalX, GlobalY) {
    interact(container)
      .ignoreFrom('a')
      .ignoreFrom('p')
      .draggable({
        modifiers: [
          interact.modifiers.snap({
            targets: [interact.createSnapGrid({ x: 30, y: 30 })],
            range: Infinity,
            relativePoints: [{ x: 0, y: 0 }]
          }),
          interact.modifiers.restrict({
            restriction: document.getElementById("body"),
            elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
            // endOnly: true
          })
        ],
        inertia: true,
        allowFrom: handleElement,
        preventOnFilter: false
      })
      .on("dragmove", function(event) {
        GlobalX += event.dx;
        GlobalY += event.dy;

        event.target.style.webkitTransform = event.target.style.transform =
          "translate(" + GlobalX + "px, " + GlobalY + "px)";
      });
  }
  }
}
</script>

<style scoped>
.stone {
  touch-action: none;
  font-family:np;
  position:absolute;
  left:20vw;
  width:25vw;
  height:20vh;
}

.stone.mobile {
  width:90vw !important;
  left:5vw !important;
  top:0;
}

#stone2.mobile {
  width:55vw !important;
  height:45vw !important;
  left:40vw !important;
}

#stone1.mobile {
  top: 55vw !important;
  height:70vw !important;
  left:5vw !important;
}

#stone3.mobile {
  top:125vw !important;
  width:50vw !important;
  left:15vw !important;
}

a:link, a:visited, a:hover, a {
  position:relative;
  color: #3d6655;
}

a {
  display: block;
}

div#windowcontent {
  position:relative;
  width:100%;
  height:100%;
}

#windowcontent img {
  width:100%;
  height:100%;
}

#textcontainer {
  color: rgb(34, 34, 34);
  position:absolute;
  font-family:np;
  word-break:break-all;
  top:18%;
  left:19%;
  width:64%;
  height:63%;
  hyphens: auto;
  word-break:initial;
  overflow-y:auto;
  -webkit-overflow-scrolling: touch;
}

#textcontainer img {
  width:20px;
  height:auto;
}


.links {
  display:inline-block;
  padding:2px;
}
</style>